module.exports = "/static/assets/9172264a24247609bfe4e7cb10380007.png";